<div class="home-page mx-auto my-4">
    <!-- Hero -->
    <section class="home-hero">
        <h1 class="home-hero__title mt-0">Welcome to the Tiwi Land Council Permit Portal</h1>
        <p class="home-hero__lead">You need a permit to visit the Tiwi Islands. Apply online, and we&rsquo;ll point you to the right one for your visit.</p>
        <div class="d-flex flex-wrap gap-2">
            <a class="btn btn-primary ms-0" routerLink="/apply">Apply for a permit</a>
            <a class="btn btn-outline-secondary" routerLink="/my-permits">View my permits</a>
            <!-- The FAQ page is a seeded system page (slug "faq", locked + undeletable), so this
                 link always resolves; TLC author its content in Config → Pages. -->
            <a class="btn btn-outline-secondary" routerLink="/faq">FAQ</a>
        </div>
    </section>

    <!-- How it works. The permit types themselves live on /apply - showing them here
         too meant "Apply for a permit" led to a page the visitor had already seen. -->
    <section class="mt-5">
        <h2 class="home-section-label">How it works</h2>
        <ol class="home-steps row g-3 mt-1">
            @for (step of steps; track step.title; let i = $index) {
                <li class="col-md-4">
                    <div class="home-card h-100">
                        <span class="home-step__number">{{ i + 1 }}</span>
                        <h3 class="h6 mt-3 mb-1">{{ step.title }}</h3>
                        <p class="text-muted small mb-0">{{ step.body }}</p>
                    </div>
                </li>
            }
        </ol>
    </section>

    <!-- Closing call to action -->
    <section class="mt-5">
        <div class="home-cta">
            <div>
                <h2 class="h5 mt-0 mb-1">Ready to apply?</h2>
                <p class="mb-0 text-muted">Tell us why you&rsquo;re visiting and we&rsquo;ll take you to the right application.</p>
            </div>
            <a class="btn btn-primary ms-0 flex-shrink-0" routerLink="/apply">Apply for a permit</a>
        </div>
    </section>
</div>
